module.exports = __webpack_public_path__ + "static/media/guilherme-teles.7f071418.jpeg";